// Login.jsx — zenithpost.ai
// Redesigned: dark editorial theme, larger card, zenithpost.ai branding

import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

const D = {
  bg:"#0B0C10", surface:"#0F1117", card:"#13151E",
  border:"rgba(255,255,255,0.07)", accent:"#6C7EF8",
  accentDim:"rgba(108,126,248,0.10)", accentBorder:"rgba(108,126,248,0.22)",
  accentGlow:"rgba(108,126,248,0.28)", success:"#34D399",
  danger:"#F87171", dangerDim:"rgba(248,113,113,0.09)", purple:"#A378F8",
  textPrimary:"#EDEEF5", textSec: "#C4C9DC",  textMuted: "#7A82A0",
  fontDisplay:"'Bricolage Grotesque','Plus Jakarta Sans',sans-serif",
  fontBody:"'DM Sans',sans-serif", fontMono:"'JetBrains Mono',monospace",
};

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,700;12..96,800&family=DM+Sans:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');
  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
  body { background:${D.bg}; color:${D.textPrimary}; font-family:${D.fontBody}; -webkit-font-smoothing:antialiased; }
  ::-webkit-scrollbar { width:4px; }
  ::-webkit-scrollbar-thumb { background:rgba(255,255,255,0.07); border-radius:99px; }
  @keyframes fadeUp { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
  @keyframes spin   { to{transform:rotate(360deg)} }
  @keyframes pulse  { 0%,100%{opacity:1} 50%{opacity:0.35} }
  .fu  { animation:fadeUp 0.55s cubic-bezier(0.22,1,0.36,1) both; }
  .d1  { animation-delay:0.07s; }
  .d2  { animation-delay:0.14s; }
  .pg { position:fixed; inset:0; z-index:0; pointer-events:none;
    background: radial-gradient(ellipse 55% 45% at 20% 10%,rgba(108,126,248,0.07) 0%,transparent 60%),
                radial-gradient(ellipse 40% 35% at 80% 90%,rgba(163,120,248,0.05) 0%,transparent 55%); }
  .f-group { margin-bottom:20px; }
  .f-label-row { display:flex; justify-content:space-between; align-items:center; margin-bottom:7px; }
  .f-label { font-family:${D.fontBody}; font-weight:600; font-size:14px; color:${D.textSec}; }
  .f-forgot { font-family:${D.fontBody}; font-size:12.5px; color:${D.accent}; font-weight:600; background:none; border:none; cursor:pointer; padding:0; transition:opacity 0.15s; }
  .f-forgot:hover { opacity:0.8; }
  .f-input { width:100%; padding:13px 16px; border-radius:10px; background:rgba(255,255,255,0.04); border:1px solid ${D.border}; color:${D.textPrimary}; font-family:${D.fontBody}; font-size:15px; outline:none; transition:border-color 0.18s,box-shadow 0.18s; }
  .f-input::placeholder { color:${D.textMuted}; }
  .f-input:focus { border-color:${D.accent}; box-shadow:0 0 0 3px ${D.accentDim}; }
  .f-input.err { border-color:${D.danger}; }
  .f-wrap { position:relative; }
  .f-eye { position:absolute; right:13px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:${D.textMuted}; font-size:16px; padding:3px; display:flex; align-items:center; transition:color 0.15s; }
  .f-eye:hover { color:${D.textSec}; }
  .f-err { margin-top:5px; font-size:12px; color:${D.danger}; font-family:${D.fontBody}; display:flex; align-items:center; gap:4px; }
  .btn-p { width:100%; padding:14px; border-radius:11px; border:none; background:linear-gradient(135deg,${D.accent} 0%,#8B72F8 100%); color:white; font-family:${D.fontBody}; font-size:15px; font-weight:700; cursor:pointer; box-shadow:0 6px 24px ${D.accentGlow}; transition:transform 0.15s,box-shadow 0.15s,opacity 0.15s; display:flex; align-items:center; justify-content:center; gap:8px; }
  .btn-p:hover:not(:disabled) { transform:translateY(-1px); box-shadow:0 10px 32px rgba(108,126,248,0.42); }
  .btn-p:disabled { opacity:0.55; cursor:not-allowed; }
  .spinner { width:15px; height:15px; border-radius:50%; border:2px solid rgba(255,255,255,0.25); border-top-color:white; animation:spin 0.7s linear infinite; flex-shrink:0; }
  .divider { display:flex; align-items:center; gap:12px; margin:20px 0; }
  .div-line { flex:1; height:1px; background:${D.border}; }
  .div-txt { font-family:${D.fontMono}; font-size:10px; color:${D.textMuted}; }
  .pulse-dot { width:6px; height:6px; border-radius:50%; background:${D.success}; animation:pulse 2s ease infinite; display:inline-block; }
  @media (max-width: 480px) {
    .card-header { padding: 24px 22px 22px !important; }
    .card-body   { padding: 24px 22px 26px !important; }
    .forgot-modal { padding: 24px 20px 22px !important; }
  }
`;

export default function Login() {
  const navigate   = useNavigate();
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw]     = useState(false);
  const [errors, setErrors]     = useState({});
  const [loading, setLoading]   = useState(false);
  const [showForgot, setShowForgot]         = useState(false);
const [forgotEmail, setForgotEmail]       = useState("");
const [forgotStatus, setForgotStatus]     = useState("idle"); // idle | sending | sent | error
const [forgotErrMsg, setForgotErrMsg]     = useState("");

  const validate = () => {
    const e = {};
    if (!email.trim())    e.email    = "Email is required";
    if (!password.trim()) e.password = "Password is required";
    setErrors(e);
    return !Object.keys(e).length;
  };

const handleLogin = async () => {
  setErrors({});
  if (!validate()) return;
  setLoading(true);
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL || "http://localhost:8000"}/api/auth/login`,
      { email, password }
    );
    
    const token = res.data.token || res.data.access_token;
    if (!token) throw new Error("No token received");

    // Always wipe previous session data on login so stale results from a
    // previous session (or a different tab) never bleed into the new one.
    ["zp_domain","zp_topics","zp_selected","zp_results",
     "zp_tabMap","zp_openMap","zp_zipUrls","zp_queue"].forEach(k => sessionStorage.removeItem(k));

    localStorage.setItem("auth_token", token);
    navigate("/home");
  } catch (err) {
    setErrors({ general: err.response?.data?.detail || "Incorrect email or password." });
  } finally { 
    setLoading(false); 
  }
};

const handleForgotPassword = async () => {
  if (!forgotEmail.trim()) return;
  setForgotStatus("sending");
  setForgotErrMsg("");
  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL || "http://localhost:8000"}/api/auth/forgot-password`,
      { email: forgotEmail }
    );
    // Backend sends the email via Resend — always show success (never reveal if email exists)
    setForgotStatus("sent");
  } catch (err) {
    setForgotStatus("error");
    setForgotErrMsg("Something went wrong. Please try again.");
  }
};

  const onKey = e => { if (e.key === "Enter") handleLogin(); };
  const clr   = f => setErrors(v => ({ ...v, [f]: undefined }));

  return (
    <>
      <style>{CSS}</style>
      <div className="pg" />
      <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"40px 20px", position:"relative", zIndex:1 }}>

        {/* Logo */}
        <div 
  onClick={() => navigate("/")} 
  style={{ cursor:"pointer", display:"flex", flexDirection:"column", alignItems:"center", gap:12 }}
>
  <div style={{ width:54, height:54, borderRadius:15, background:`linear-gradient(135deg,${D.accent} 0%,${D.purple} 100%)`, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:D.fontDisplay, fontWeight:800, fontSize:26, color:"white", boxShadow:`0 8px 28px ${D.accentGlow}` }}>Z</div>
  <div style={{ fontFamily:D.fontDisplay, fontWeight:700, fontSize:16, color:D.textPrimary }}>zenithpost<span style={{ color:D.accent }}>.ai</span></div>
</div>

        {/* Status chip */}
        <div className="fu" style={{ marginBottom:20 }}>
          <div style={{ display:"inline-flex", alignItems:"center", gap:7, padding:"4px 12px", borderRadius:99, background:"rgba(52,211,153,0.08)", border:"1px solid rgba(52,211,153,0.20)", fontFamily:D.fontMono, fontSize:10.5, color:"#34D399" }}>
            <span className="pulse-dot" />Your AI content platform is ready.
          </div>
        </div>

        {/* Card */}
        <div className="fu d1" style={{ width:"100%", maxWidth:480, background:D.card, borderRadius:22, border:`1px solid ${D.border}`, boxShadow:"0 32px 80px rgba(0,0,0,0.45)", overflow:"hidden" }}>

          {/* Header */}
          <div className="card-header" style={{ background:"linear-gradient(135deg,#0D0D12 0%,#1A1A2E 100%)", padding:"34px 36px 30px", position:"relative", overflow:"hidden" }}>
            <div style={{ position:"absolute", inset:0, background:"radial-gradient(ellipse at 80% 50%,rgba(108,126,248,0.28) 0%,transparent 60%)", pointerEvents:"none" }} />
            <div style={{ fontFamily:D.fontMono, fontSize:10.5, color:"rgba(255,255,255,0.35)", letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:12 }}>Welcome back</div>
            <div style={{ fontFamily:D.fontDisplay, fontWeight:800, fontSize:28, color:"white", lineHeight:1.15, marginBottom:8 }}>Sign in to your account</div>
            <div style={{ fontSize:14.5, color:"rgba(255,255,255,0.48)", lineHeight:1.65 }}>Know what to post. Write it in seconds.</div>
          </div>

          {/* Form */}
          <div className="card-body" style={{ padding:"32px 36px 36px" }}>
            {errors.general && (
              <div style={{ display:"flex", gap:10, padding:"12px 16px", marginBottom:20, borderRadius:10, background:"rgba(248,113,113,0.09)", border:"1px solid rgba(248,113,113,0.22)" }}>
                <span style={{ fontSize:15, flexShrink:0 }}>⚠</span>
                <span style={{ fontSize:13, color:D.danger, lineHeight:1.55 }}>{errors.general}</span>
              </div>
            )}

            {/* Email */}
            <div className="f-group">
              <label className="f-label" style={{ display:"block", marginBottom:7 }}>Email address</label>
              <input className={`f-input${errors.email?" err":""}`} type="email" placeholder="you@company.com"
                value={email} onChange={e=>{setEmail(e.target.value);clr("email");}} onKeyDown={onKey} />
              {errors.email && <div className="f-err">⚠ {errors.email}</div>}
            </div>

            {/* Password */}
            <div className="f-group">
              <div className="f-label-row">
                <span className="f-label">Password</span>
                <button className="f-forgot" type="button" onClick={() => setShowForgot(true)}>Forgot password?</button>
              </div>
              <div className="f-wrap">
                <input className={`f-input${errors.password?" err":""}`} type={showPw?"text":"password"} placeholder="••••••••"
                  value={password} onChange={e=>{setPassword(e.target.value);clr("password");}} onKeyDown={onKey}
                  style={{ paddingRight:44 }} />
                <button className="f-eye" type="button" onClick={()=>setShowPw(s=>!s)} tabIndex={-1}>{showPw?"🙈":"👁"}</button>
              </div>
              {errors.password && <div className="f-err">⚠ {errors.password}</div>}
            </div>

            {/* Submit */}
            <div style={{ marginTop:28 }}>
              <button className="btn-p" onClick={handleLogin} disabled={loading}>
                {loading ? <><div className="spinner" />Signing in…</> : "Sign In →"}
              </button>
            </div>

            <div className="divider"><div className="div-line" /><span className="div-txt">OR</span><div className="div-line" /></div>

            <div style={{ textAlign:"center", fontSize:13.5, color:D.textSec }}>
              Don't have an account?{" "}
              <Link to="/signup" style={{ color:D.accent, fontWeight:700, textDecoration:"none" }}>Create one</Link>
            </div>
          </div>
        </div>

        <div className="fu d2" style={{ marginTop:24, textAlign:"center" }}>
          <p style={{ fontFamily:D.fontMono, fontSize:10.5, color:D.textMuted }}>© {new Date().getFullYear()} zenithpost.ai · Secure sign-in</p>
        </div>
      </div>
      {showForgot && (
  <div style={{ position:"fixed", inset:0, zIndex:999, background:"rgba(0,0,0,0.7)", backdropFilter:"blur(8px)", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
    <div className="forgot-modal" style={{ width:"100%", maxWidth:420, background:D.card, borderRadius:20, border:`1px solid ${D.border}`, padding:"36px 36px 32px", boxShadow:"0 32px 80px rgba(0,0,0,0.5)" }}>
      <div style={{ fontFamily:D.fontMono, fontSize:10, color:D.accent, letterSpacing:"0.13em", textTransform:"uppercase", marginBottom:12 }}>Password Reset</div>
      {forgotStatus === "sent" ? (
        <>
          <div style={{ fontSize:36, marginBottom:16, textAlign:"center" }}>📬</div>
          <div style={{ fontFamily:D.fontDisplay, fontWeight:700, fontSize:20, color:D.textPrimary, marginBottom:10, textAlign:"center" }}>Check your inbox</div>
          <p style={{ fontSize:14, color:D.textSec, lineHeight:1.7, textAlign:"center", marginBottom:24 }}>
            We sent a password reset link to <strong style={{ color:D.textPrimary }}>{forgotEmail}</strong>. 
            Check your spam folder if you don't see it within a few minutes.
          </p>
          <button onClick={() => { setShowForgot(false); setForgotStatus("idle"); setForgotEmail(""); }}
            style={{ width:"100%", padding:"12px", borderRadius:10, border:`1px solid ${D.border}`, background:"rgba(255,255,255,0.04)", color:D.textSec, fontFamily:D.fontBody, fontSize:14, fontWeight:600, cursor:"pointer" }}>
            Back to login
          </button>
        </>
      ) : (
        <>
          <div style={{ fontFamily:D.fontDisplay, fontWeight:700, fontSize:22, color:D.textPrimary, marginBottom:8 }}>Reset your password</div>
          <p style={{ fontSize:14, color:D.textSec, lineHeight:1.7, marginBottom:24 }}>Enter your account email and we'll send you a link to reset your password.</p>
          {forgotStatus === "error" && (
            <div style={{ padding:"10px 14px", borderRadius:9, background:"rgba(248,113,113,0.09)", border:"1px solid rgba(248,113,113,0.22)", marginBottom:16, fontSize:13, color:D.danger }}>{forgotErrMsg}</div>
          )}
          <div style={{ marginBottom:20 }}>
            <label style={{ display:"block", fontFamily:D.fontBody, fontWeight:600, fontSize:13, color:D.textSec, marginBottom:7 }}>Email address</label>
            <input className="f-input" type="email" placeholder="you@company.com"
              value={forgotEmail} onChange={e => setForgotEmail(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleForgotPassword()} />
          </div>
          <div style={{ display:"flex", gap:10 }}>
            <button onClick={() => { setShowForgot(false); setForgotStatus("idle"); setForgotEmail(""); }}
              style={{ flex:1, padding:"11px", borderRadius:10, border:`1px solid ${D.border}`, background:"rgba(255,255,255,0.04)", color:D.textSec, fontFamily:D.fontBody, fontSize:14, fontWeight:600, cursor:"pointer" }}>
              Cancel
            </button>
            <button onClick={handleForgotPassword} disabled={forgotStatus === "sending" || !forgotEmail.trim()}
              style={{ flex:2, padding:"11px", borderRadius:10, border:"none", background:`linear-gradient(135deg,${D.accent},#8B72F8)`, color:"white", fontFamily:D.fontBody, fontSize:14, fontWeight:700, cursor:"pointer", opacity: forgotStatus === "sending" ? 0.6 : 1 }}>
              {forgotStatus === "sending" ? "Sending…" : "Send reset link →"}
            </button>
          </div>
        </>
      )}
    </div>
  </div>
)}
    </>
  );
}